import Popover from "@mui/material/Popover";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import React, {Fragment, useEffect, useState} from "react";
import {IDataSpell} from "../_interfaces/IDataSpell";
import {v4} from "uuid";
import {InfoSpellSubscriber} from "../_helper/InfoSpellBehave";


function SpellPopover() {

    const [infoSpell, setInfoSpell] = useState<IDataSpell | null>(null);
    const [infoSpellAncor, setInfoSpellAncor] = useState<Element | HTMLElement | null>(null);
    const [infoSpellOpen, setInfoSpellOpen] = useState(false);

    useEffect(() => {
        const subscription = InfoSpellSubscriber.subscribe((newValue) => {
            setInfoSpell(newValue.pop);
            setInfoSpellAncor(newValue.popEl)
            setInfoSpellOpen(newValue.popOpen)
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const handleClose = () => {
        setInfoSpell(null);
        setInfoSpellAncor(null)
        setInfoSpellOpen(false);
    }

    if (infoSpellOpen) return <Popover
        open={infoSpellOpen}
        anchorEl={infoSpellAncor}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
    >
        <Grid container spacing={1} style={{padding: 10}}>
            <Grid item xs={10}>
                {infoSpell!.name}
            </Grid>
            <Grid item xs={2}>
                <Button onClick={() => handleClose()}>X</Button>
            </Grid>
            <Grid item xs={12}>
                Disziplin: {infoSpell!.discipline} Kreis: {infoSpell!.circle}
            </Grid>
            <Grid item xs={4}>
                Fäden: {infoSpell!.threads}
            </Grid>
            <Grid item xs={4}>
                Webschwierigkeit: {infoSpell!.weaving}/{infoSpell!.attune}
            </Grid>
            <Grid item xs={4}>
                Wirkschwierigkeit: {infoSpell!.casting}
            </Grid>
            <Grid item xs={4}>
                Reichweite: {infoSpell!.distance}
            </Grid>
            <Grid item xs={4}>
                Wirkungsdauer: {infoSpell!.dur}
            </Grid>
            <Grid item xs={4}>
                Wirkung: {infoSpell!.eff}
            </Grid>
            <Grid item xs={12}>
                Beschreibung:
                {infoSpell!.desc && infoSpell!.desc.map(desc => <div
                    key={v4()}>{desc}</div>)}
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={3}>
                        Zusätzliche Erfolge
                    </Grid>
                    <Grid item xs={9}>
                        {infoSpell!.as ?
                            <div key={v4()}>{infoSpell!.as.txt}</div>
                            : null}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={3}>
                        Zusätzliche Fäden
                    </Grid>
                    <Grid item xs={9}>
                        {infoSpell?.at ?
                            infoSpell.at.map(at => <div key={v4()}>{at.txt}</div>)
                            : null}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </Popover>

    else return <Fragment/>
}

export default SpellPopover;